import FormstepDetail from "../../../../global/components/FormstepDetail/FormstepDetail.vue";

import HttpAPI from "../../../../global/compositionAPI/HttpAPI";
import NotificationAPI from "../../../../global/compositionAPI/NotificationAPI";

import {
  cloneDeep,
} from "lodash-es";

// @vue/component
export default {
  name: "InstrumentBasisdaten",
  components: {
    FormstepDetail,
  },
  props: {
    instrument: {
      type: Object,
      required: true,
    },
    instrumenteUrl: {
      type: String,
      required: true,
    },
  },
  emits: [
    "updateInstrument",
  ],
  setup() {
    const {
      putHttp,
    } = HttpAPI();

    const {
      addNotification,
    } = NotificationAPI();

    return {
      addNotification,
      putHttp,
    };
  },
  data() {
    return {
      options: {
        label: "_LBL_INSTRUMENT_BASISDATEN_",
        list: [
          {
            id: "foi_kbez",
            type: "text",
            label: "_LBL_INSTRUMENT_KURZBEZEICHNUNG_",
            showLabel: true,
            view: "v",
            maxlength: 60,
            required: true,
          },
          {
            id: "foi_bez",
            type: "textarea",
            label: "_LBL_INSTRUMENT_BEZEICHNUNG_",
            showLabel: true,
            view: "v-alt",
            maxlength: 200,
            required: true,
          },
        ],
        required: true,
        saveCallback: this.save,
      },
    };
  },
  methods: {
    save({ model }) {
      const DATA = cloneDeep(model);
      return new Promise((resolve, reject) => {
        this.putHttp({
          url: this.instrumenteUrl,
          data: DATA,
        }).then(
          response => {
            this.$emit("updateInstrument", { instrument: response });
            this.addNotification({ text: "_MSG_INSTUMENT_BASISDATEN_AENDERUNG_GESCHPEICHERT_" });
            resolve();
          },
          error => {
            reject(error);
          }
        );
      });
    },
  },
};
